<template>
    <div>
      <modal-form v-model="show" text-submit="Atualizar Dados" size="lg" :submit="submit">
        <template v-slot:title>
          Atualizar conta de pagamento
        </template>
        <template v-slot:body>
          <v-alert color="info" border="left" text>
             <v-icon color="info" class="mr-2">fas fa-exclamation</v-icon>Seus dados bancários estão incorretos, por gentileza, revisar e enviar novamente
          </v-alert>
          <v-row>
            <v-col cols="12" class="px-0">
              <input-seleciona-banco
                required
                v-model="model"
              />
            </v-col>
            <v-col cols="4">
              <input-text label="Agência" v-model="model.Agencia" v-mask="'####'" required />
            </v-col>
            <v-col cols="5">
              <input-text label="Conta"
                v-mask="$api.UI.Format.MascaraDigito(15)"
                v-model="model.Conta"
                required />
            </v-col>
          </v-row>
          <v-col cols="12">
            <input-radiogroup row required name="Tipo Conta" v-model="model.TipoConta">
              <v-radio label="Conta Corrente" :value="2" />
              <v-radio label="Conta Poupança" :value="1" />
            </input-radiogroup>
          </v-col>
        </template>
      </modal-form>
    </div>
  </template>

<script>
export default {
  data () {
    return {
      show: false,
      proposta: {},
      model: {}
    }
  },
  methods: {
    openModal: function (proposta) {
      this.show = true
      this.proposta = proposta
    },
    close (param) {
      this.show = false;
      this.$emit('close', param);
    },
    submit () {
      const th = this

      var dto = {
        dto: {
          CodigoProposta: th.proposta.Codigo
        },
        dtoPagto: {
          CodigoBanco: th.model.CodigoBanco,
          TipoConta: th.model.TipoConta,
          Agencia: th.model.Agencia,
          Conta: th.model.Conta.split('-')[0],
          ContaDig: th.model.Conta.split('-')[1]
        }
      }

      th.$api.Multiplo.PropostaAtualizarContaPagamento(dto).then(function (response) {
        if (th.$api.UI.PostLoadData(response, true)) {
          th.$api.UI.Mensagem('info', 'Dados bancários da proposta atualizados com sucesso!', () => th.close(true), 'Resultado da Atualização')
        }
      })
    }
  },
}
</script>
